import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import { GeneralRoute } from './utils/routes';
import RootLayout from './components/layouts';

function App() {
	return (
		<>
			<Router>
				<Routes>
					{GeneralRoute.map((root) =>
						root.content.map((val) => (
							<Route
								path={val.path}
								element={<RootLayout>{val.component}</RootLayout>}
							/>
						))
					)}
				</Routes>
			</Router>
		</>
	);
}

export default App;
